import { IconType, defaultProps } from './types';

/**
 * Icono Minus
 */
export const Minus = ({
  className,
  width,
  height,
  color = defaultProps.color,
}: IconType): JSX.Element => (
  <svg
    {...(className ? { className: className } : {})}
    {...(width ? { width: width } : {})}
    {...(height ? { height: height } : {})}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      d="M20 11.25a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h16Z"
      fill={color}
    />
  </svg>
);
